export default {"src":"/_next/static/media/WhoWeAre_001A.bb1f8518.JPG","height":680,"width":1920};